import React from 'react';
import ArrowRight from '@/icons/ArrowRight';
import styles from './styles.module.css'
import { getFolderIdFromURL } from '@/utils/getFolderId';

interface Props {
  assessmentCount: number;
  folderName?: string | null;
}

const DashboardHeader = ({ folderName='', assessmentCount}: Props) => {

  const handleGoBack = () => {
    window.location.href = `${window.location.origin}/edge/foldermanagement?folderID=${getFolderIdFromURL()}&autoMatch=false`;
  };
  
  return (
    <div className={styles.header}
      style={{
        // top: '54px',
      }}
    >
      <div
      className={styles.header_content_title_space}
      >
      <div
      className={styles.header_content}>
        <div style={{display: 'flex', fontSize: '16px', cursor: 'pointer', gap: '8px'}} onClick={handleGoBack}>
        <div style={{ rotate: '180deg', }}><ArrowRight /></div>
          <div className={styles.header_title}>{folderName}</div>
        </div>
        <div>{assessmentCount>0 && <div>&nbsp; / Assessments ({assessmentCount})</div>}</div>
      </div>
      </div>
    </div>
  )

}

export default DashboardHeader